(function () {
	angular
		.module('trackeye')
		.controller('FleetController', FleetController);

	FleetController.$inject = [
		"AppFactory",
		"AuthService",
		"AccountService",
		"ModalService",
		"DeviceService",
		"OpenLayersService",
		"NotificationService",
		"PositionsService",
		"HttpQueue",
		"$state", "$scope", "$window", "$rootScope", "$timeout", "$localStorage"];

	function FleetController(
		AppFactory,
		AuthService,
		AccountService,
		ModalService,
		DeviceService,
		OpenLayersService,
		NotificationService,
		PositionsService,
		HttpQueue,
		$state, $scope, $window, $rootScope, $timeout, $localStorage)
	{
		var vm = this,
			tmp_devices = [];

		vm.marpleUrl = AppFactory.getMarpleUrl();
		vm.is_loading = false;

		vm.app = AppFactory;

		// Selected device
		vm.selected = DeviceService.getSelectedDevice();

		vm.message = DeviceService.getSelectedMessage();
		vm.ordering = !$localStorage.ordering ? 'relevance' : $localStorage.ordering.orderBy;
		vm.orderingReverse = !$localStorage.ordering ? false : $localStorage.ordering.reverse;

		vm.device_search = "";

		vm.selectedFleet = {
			isDefault: true
		};

		vm.account = AccountService.get();
		vm.deviceForm = {};
		vm.deviceFormData = {};
		vm.deviceFleets = [];
		vm.devices = [];
		vm.popup_devices = [];

		var notificationMessageModal = ModalService.create('notification-message', vm);

		var addDeviceModal = ModalService.create('add-device', vm),
			hasPoliceRapid = undefined,
			search_input = "";

		$scope.$on('Modal.addDevice', function() {
			addDeviceModal.open();
		});

		$scope.$on('DeviceService.initialized', function () {
			var devices = DeviceService.getSutDevices().slice();
			devices = sortList(devices);
			devices = shortenList(devices, vm.current_page_size);
			devices = addSelected(devices);
			devices.forEach(function(device) {
				device.latest.fetchAddress('initial');
			});

			vm.devices = devices;
			hasPoliceRapid = DeviceService.hasRapidPoliceDevices();
		});

		$scope.$on('DeviceService.data', function() {
			vm.devices.forEach(function(device) {
				device.latest.fetchAddress('interval');
			});
		});

		$scope.$on('DeviceService.newDevice', function (event, device) {
			vm.devices.push(device);

			OpenLayersService.createCircle(device);
			OpenLayersService.createIcon(device);
		});

		$scope.$on('DeviceService.selected', function (device) {
			vm.selected = DeviceService.getSelectedDevice();
			vm.deviceFleets = [vm.selectedFleet].concat(DeviceService.getFleets());
		});


		$scope.$on('OpenLayersService.ready', function (e, instance) {
			OpenLayersService.updateSize();
			instance.addControlByElement('openlayers-gmaps-btn');
			instance.addOverlayByElement('popup', 'openlayers-marker-popup');

			OpenLayersService.on('popup.open', function(features) {
				vm.popup_devices = features.map(function(feature) {
					return feature.device;
				});
				$scope.$apply();
			});
			OpenLayersService.on('popup.close', function() {
				vm.popup_devices = [];
			});
		});

		$scope.$on('DeviceService.not-found', function (event) {
			addDeviceModal.open();
		});

		vm.hasPoliceRapidDevices = function () {
			if (hasPoliceRapid !== undefined) {
				return hasPoliceRapid;
			}

			return hasPoliceRapid = DeviceService.hasRapidPoliceDevices();
		}

		vm.max_search_results = 30;
		vm.current_page_size = 40;
		vm.page_size_step = 20;
		vm.search_num_results = 0;
		vm.searchDebounce = undefined;
		vm.searchInput = "";

		vm.searchUpdate = function(search, triggerAddress, loadMore) {
			var devices = DeviceService.getSutDevices().slice(),
				search_results = [],
				page_size = vm.current_page_size;

			if (vm.isShowingFleet()) {
				devices = vm.selectedFleet.devices.slice();
				page_size = devices.length;
			}

			if (vm.searchDebounce) {
				$timeout.cancel(vm.searchDebounce);
			} else {
				isWorking(true);
			}

			HttpQueue.cancel('search-debounced');
			HttpQueue.cancel('initial');

			vm.searchDebounce = $timeout(function() {
				if (loadMore) {
					page_size = vm.current_page_size += 20;
				}

				if (search.length < 2) {
					devices = addSelected(devices);
					devices = sortList(devices);
					vm.devices = shortenList(devices, page_size);

					if (triggerAddress === true) {
						vm.devices.forEach(function(device) {
							device.latest.fetchAddress('search-debounced');
						});
					}
					return;
				}

				search = search.toLowerCase();

				search_results = devices.filter(function(device) {
					var name = device.getSearchable('name'),
						nodeid = device.getSearchable('nodeid');

					return name.indexOf(search) !== -1 || nodeid.indexOf(search) !== -1;
				});

				vm.search_num_results = search_results.length;

				search_results = shortenList(search_results, page_size);
				search_results = sortList(search_results);
				search_results.forEach(function(device) {
					device.latest.fetchAddress('search-debounced');
				});

				vm.devices = search_results;
				isWorking(false);
			}, 500);
		}

		vm.loadMoreDevices = function() {
			if (!shouldLoadMore()) {
				return;
			}

			vm.searchUpdate(vm.searchInput, true, true);
		}

		function shouldLoadMore() {
			var page_size = vm.current_page_size,
				search_results = vm.search_num_results;

			if (vm.searchInput.length) {
				if (page_size >= search_results) {
					return false
				}
			} else if (
				page_size > vm.devices.length ||
				page_size > DeviceService.getSutDevices().length ||
				vm.isShowingFleet()
				)
			{
				return false;
			}

			return true;
		}

		function sortList(devices) {
			var last_selected = $localStorage.last_selected,
				now = new Date();

			if (vm.ordering == 'relevance') {
				devices.forEach(function(device) {
					var score = device.getTimescore(now),
						last_selected_index = last_selected.indexOf(device.getNodeId());

					if (last_selected_index >= 0) {
						score += last_selected.length / (last_selected_index + 1)
					}

					if (vm.isSelected(device)) {
						score += 1;
					}

					device.setSearchScore(score);
				});
			} else if (vm.ordering == 'battery') {
				devices.forEach(function(device) {
					device.setSearchScore(device.getBatteryscore())
				});
			}

			devices.sort(function(device1, device2) {
				var factor1 = "",
					factor2 = "";

				if (vm.ordering == 'name') {
					factor1 = device1.getNameOrNodeId().toLowerCase(),
					factor2 = device2.getNameOrNodeId().toLowerCase();
				} else if (vm.ordering == 'nodeid') {
					factor1 = device1.getNodeId().toLowerCase(),
					factor2 = device2.getNodeId().toLowerCase();
				} else if (vm.ordering == 'time') {
					factor1 = device1.getTimescore(now),
					factor2 = device2.getTimescore(now);
				} else if (vm.ordering == 'relevance' || vm.ordering == 'battery') {
					factor1 = device1.getSearchScore(),
					factor2 = device2.getSearchScore();

					if (factor1 > factor2) {
						return -1;
					} else if (factor1 < factor2) {
						return 1;
					}
					return 0;
				}

				if (factor1 > factor2) {
					return 1;
				} else if (factor1 < factor2) {
					return -1;
				}
				return 0;
			});

			return vm.orderingReverse ? devices.reverse() : devices;
		}

		function addSelected(devices) {
			if (vm.isShowingFleet()) {
				return devices;
			}

			if (devices.indexOf(vm.selected) < 0) {
				devices.unshift(vm.selected);
			}
			return devices;
		}

		function shortenList(devices, size) {
			if (devices.length > size) {
				while (devices.length > size) {
					devices.pop();
				}
			}
			return devices;
		}

		vm.openNotificationMessage = function () {
			notificationMessageModal.open();
		}

		vm.openAddDeviceModal = function() {
			addDeviceModal.open();
		};

		vm.addDevice = function (formData) {
			if (vm.deviceForm.$dirty) {
				isWorking(true);
				DeviceService.verifyDevice(formData.number, formData.code).then(function () {
					vm.deviceForm.device_number.$setValidity('invalidDevice', true);
					DeviceService.claimDevice(formData.number, formData.code).then(function () {
						DeviceService.add(formData.number).then(function () {
							var device = DeviceService.findOne(formData.number);

							if (formData.name) {
								DeviceService.updateDevice(device, {
									name: formData.name
								});
							}

							$rootScope.$broadcast('DeviceService.newDevice', device);
							isWorking(false);
							NotificationService.success("STR_NOTICE_DEVICE_WAS_ADDED");

							vm.deviceFormData = {};
							vm.deviceForm.$setPristine();
							vm.deviceForm.$setUntouched();
						}, isNotWorking);
					}, function () {
						//@todo forward error to backend
						NotificationService.danger("STR_ERROR_BACKEND");
						isWorking(false);
					});
				}, function () {
					isWorking(false);
					vm.deviceForm.device_number.$setValidity('invalidDevice', false);
				});
			}
		};

		vm.gmaps = function () {
			var coord = OpenLayersService.getCurrentCoord();

			if (coord) {
				$window.open("https://maps.google.com/maps?z=10&t=k&q=loc:" + coord.getLat() + "," + coord.getLon(), "_blank");
			} else {
				NotificationService.info('STR_NOTICE_NO_LOCATION_DATA')
			}
		};

		vm.toggleFleet = function () {
			if (vm.selectedFleet.isDefault) {
				PositionsService.fleet(false);

				$rootScope.$broadcast('Sidebar.open');
				DeviceService.setSelectedDevice(vm.selected);
				//OpenLayersService.showFeatures([vm.selected.getUuid()]);
				OpenLayersService.setFocus();
				vm.searchUpdate(vm.searchInput);
			} else {
				devices = vm.selectedFleet.devices;
				var names = devices.map(function (device) {
					device.latest.fetchAddress('fleet-toggle');
					return device.selectedOrLatest().hasLonLat() ? device.getUuid() : null
				}).filter(function(name) {
					return !!name;
				});

				PositionsService.fleet(devices);

				OpenLayersService
					.showFeatures(names)
					.hideCircles()
					.setFocus('markerLayer');

				vm.searchUpdate(vm.searchInput, true);
				$rootScope.$broadcast('Sidebar.collapse');
			}
		};

		vm.isShowingFleet = function() {
			return PositionsService.fleet();
		};

		vm.isInActiveFleet = function (device) {
			if (vm.isShowingFleet())
				return vm.selectedFleet.name === device.getFleet().name;

			return true;
		};

		vm.orderFleetBy = function (property) {
			if (property === vm.ordering)
				vm.orderingReverse = !vm.orderingReverse;

			vm.ordering = property;

			$localStorage.ordering = {
				orderBy: property,
				reverse: vm.orderingReverse
			};
			vm.devices = sortList(vm.devices);
		};

		vm.isOrdering = function (property) {
			return (property === vm.ordering);
		};

		vm._info = function(e,device) {
			e.stopPropagation();
			console.log(device);
		}
		/**
		 * Sets a device as selected.
		 * @param nodeid
		 */
		vm.selectDevice = function (nodeid) {
			var device = DeviceService.find(nodeid);

			vm.selected = device;

			if (vm.isShowingFleet()) {
				OpenLayersService.setCenter(device.latest);
			} else {
				DeviceService.setSelectedDevice(device);
			}

			if (!device.isActive()) {
				if (DeviceService.hasPrepaidDevices()) {
					$state.go('dashboard.main.pages', {page: 'subscription'});
					NotificationService.warning("STR_NOTICE_DEVICE_IS_INACTIVE_FILL_UP");
				} else {
					NotificationService.warning("STR_NOTICE_DEVICE_IS_INACTIVE");
				}
			}
		};

		vm.getMeasureText = function (device) {
			var feat = device.features;

			if (feat.isCapture())
				return "-";

			if (feat.isPower()) {
				var time = device.latest.getHourValueI1();
				return time[0]+'t '+time[1]+'m';
			}

			if (feat.hasDistanceMeter()) {
				return device.getDistance() + " " + feat.getDistanceUnit();
			}

			if (device.latest.hasI2CTemperature()) {
				let temperature = Math.round(device.latest.getI2CTemperature() * 10) / 10 + " &deg;C";
				if (device.latest.hasTemperature()) {
					temperature = temperature+"\n(amb "+ device.latest.getTemperature() + " &deg;C)"; 
				}
				return temperature;
			}

			if (device.latest.hasTemperature()) {
				return device.latest.getTemperature() + " &deg;C";
			}

			return "-";
		};

		vm.getMeasureClass = function (device) {
			var feat = device.features;

			if (feat.hasDistanceMeter() || feat.isCapture() || feat.isPower())
				return null;
			// console.log(device.hasTemperatureBoundaries());
			if ((device.latest.hasTemperature() || device.latest.hasI2CTemperature()) && device.hasTemperatureBoundaries()) {
				var temp = device.latest.hasI2CTemperature() ? device.latest.getI2CTemperature() : device.latest.getTemperature();
				if (device.isTemperatureLow(temp)) {
					return "temp-cold";
				} else if (device.isTemperatureHigh(temp)) {
					return "temp-hot";
				}
				return "temp-good";
			}
			return null;
		};

		vm.getHumidity = function (device) {
			if (device.latest.hasHumidity())
				return device.latest.getHumidity() + '%';

			return '-';
		}

		vm.isSelected = function (device) {
			return device.nodeid === vm.selected.nodeid;
		};

		vm.isInputInvalid = function (element_name) {
			return vm.deviceForm[element_name].$invalid && vm.deviceForm.$submitted;
		};

		vm.getDeviceFleetIcon = function (device) {
			if (device.getFleet().name) {
				return "assets/images/fleet/" + device.getFleet().image;
			}
			return false;
		};

		vm.isWorking = false;

		function isWorking(value) {
			if (!angular.isDefined(value))
				return vm.isWorking;

			return vm.isWorking = !!value;
		}

		function isNotWorking() {
			isWorking(false);
		}
	}
})();
